<template>
  <div class="be-parter-container">
    <div class="content success" v-if="hasBeenAgent">
      <van-empty>
        <img slot="image" class="image" src="./images/success.png">
        <div slot="description">
          <div class="title">您已成功加入{{ partnerName }}！</div>
          <div>请联系管理员为您分配相应的权限。</div>
        </div>
      </van-empty>
    </div>
    <div class="content" v-else>
      <van-notice-bar left-icon="volume-o" :scrollable="false" wrapable>
        请填写真实的身份信息，注册成功后不得更改！<br />
      </van-notice-bar>
      <van-cell-group>
        <van-field v-model="formValue.name" required clearable label="真实姓名" placeholder="请填写真实姓名" :maxlength="4" />
        <van-field v-model="formValue.phoneNo" required clearable label="手机号码" placeholder="请填写手机号码" :maxlength="11" />
        <van-field v-model="formValue.vcode" required clearable label="短信验证码" placeholder="请填写短信验证码" :maxlength="6"
          class="code-field">
          <template #button>
            <van-button style="width: 110px;" size="small" type="primary" @click="onSendCode" :disabled="counting">
              {{ counting ? `重新发送(${countDown}s)` : '发送验证码' }}
            </van-button>
          </template>
        </van-field>
      </van-cell-group>
      <div class="button-container">
        <van-button type="primary" round block :loading="loading" loading-type="spinner" @click="onSubmitForm">
          注册
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { bindPartner, sendVcode } from '@/services/UserService'
import * as RegExp from '@/constants/regExp'

export default {
  name: 'BePartner',
  data() {
    return {
      counting: false,
      countDown: 60,
      loading: false,
      formValue: {
        name: '',
        phoneNo: '',
        vcode: ''
      },
      hasBeenAgent: false
    }
  },
  computed: {
    ...mapGetters(['partnerName'])
  },
  mounted() {
    document.title = '加入我们'
  },
  methods: {
    async onSendCode() {
      if (!this.counting) {
        if (!this._validateFormValue('vcode')) {
          return
        }
        const openId = localStorage.getItem('openId')
        const response = await sendVcode({
          openId,
          name: this.formValue.name,
          phoneNo: this.formValue.phoneNo
        })
        if (response.code === 1000) {
          this.$toast('发送成功，请查收')
        }
        this.counting = true
        clearInterval(this.sendTimer)
        this.sendTimer = setInterval(() => {
          this.countDown = this.countDown - 1
          if (this.countDown === 0) {
            clearInterval(this.sendTimer)
            this.counting = false
            this.countDown = 60
          }
        }, 1000)
      }
    },
    async onSubmitForm() {
      if (!this._validateFormValue()) {
        return
      }
      const openId = localStorage.getItem('openId')
      this.loading = true
      const response = await bindPartner({
        openId,
        ...this.formValue
      })
      this.loading = false
      if (response.success) {
        this.$toast({
          message: '注册成功，请联系管理员分配权限'
        })
        this.hasBeenAgent = true
      } else {
        this.$toast({
          message: response.message || '注册失败，请稍后重试'
        })
        this.formValue.name = ''
        this.formValue.phoneNo = ''
        this.formValue.vcode = ''
      }
    },
    _validateFormValue(type = 'submit') {
      const { name, phoneNo, vcode } = this.formValue
      if (!RegExp.NAME_REG.test(name)) {
        this.$toast({
          message: '请填写正确的真实姓名'
        })
        return false
      }
      if (!RegExp.PHONE_REG.test(phoneNo)) {
        this.$toast({
          message: '请填写正确的手机号码'
        })
        return false
      }
      if (type === 'submit') {
        if (!RegExp.CODE_REG.test(vcode)) {
          this.$toast('请填写正确的短信验证码')
          return false
        }
      }
      return true
    }
  }
}
</script>
<style lang="stylus">
  .be-parter-container {
    .header {
      font-size: 16px;
      line-height: 40px;
      text-align: center;
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      background: #fff;
      border-bottom: 1px solid #eee;
      z-index: 1;
      .icon {
        line-height: 40px;
        position: absolute;
        left: 10px;
      }
    }
    .content {
      font-size: 14px;
      height: 100vh;
      line-height: 40px;
      &.success {
        .van-empty__image {
          width: 100px
          height 120px
          img {
            width 100px
            height 100px
            margin 0 auto
          }
        }
        .van-empty__description {
          padding-left 30px
          padding-right: 30px
          font-size 14px
          .title {
            font-size 16px
            text-align center
            margin-bottom 10px
            color #000
          }
        }
      }
      .code-field {
        padding 5px 16px
        display flex
        align-items center
      }
      .button-container {
        position: fixed
        bottom 0
        left 0
        padding: 20px 10px
        width: 100%
        background: #f7f8fa;
        .van-checkbox {
          justify-content center
          margin-bottom 5px
        }
      }
    }
  }
</style>
